import { render, staticRenderFns } from "./ExDeleteOrgObject.vue?vue&type=template&id=70759d43"
import script from "./ExDeleteOrgObject.vue?vue&type=script&lang=js"
export * from "./ExDeleteOrgObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports